import { Routes, Route, Navigate } from 'react-router-dom';
import { PermissionsUtils, RoutePaths } from '@shared/utils';
import { PermissionLevel, PermissionType } from '@shared/types';
import { AppLayout } from '@widgets';
import {
  AccountDetailsPage,
  ApplicationDetailsPage,
  ApplicationFormPage,
  ApplicationsPage,
  CustomerDetailsPage,
  CustomersPage,
  DashboardPage,
  ManualApplicationDetailsPage,
  ManualApplicationsPage,
  MessagesPage,
  RepositoryPage,
  SupplementaryApplicationFormPage,
  TransactionsPage,
} from '@pages';

export const Private = () => {
  const hasApplicationWritePermission = PermissionsUtils.hasPermission(PermissionType.APPLICATIONS, PermissionLevel.WRITE);
  const hasAccountReadPermission = PermissionsUtils.hasPermission(PermissionType.ACCOUNTS, PermissionLevel.READ);
  const hasCustomerReadPermission = PermissionsUtils.hasPermission(PermissionType.CUSTOMER, PermissionLevel.READ);

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path={RoutePaths.dashboard.path} element={<DashboardPage />} />
        <Route path={RoutePaths.applications.path} element={<ApplicationsPage />} />
        {hasApplicationWritePermission && (
          <>
            <Route path={RoutePaths.applicationsSupplementaryNew.path} element={<SupplementaryApplicationFormPage />} />
            <Route path={RoutePaths.applicationsSupplementaryEdit.path} element={<SupplementaryApplicationFormPage />} />
            <Route path={RoutePaths.applicationsNew.path} element={<ApplicationFormPage />} />
            <Route path={RoutePaths.applicationsCustomerNew.path} element={<ApplicationFormPage />} />
            <Route path={RoutePaths.applicationsEdit.path} element={<ApplicationFormPage />} />
          </>
        )}
        <Route path={RoutePaths.applicationsSupplementaryDetails.path} element={<ApplicationDetailsPage supplementary />} />
        <Route path={RoutePaths.applicationsDetails.path} element={<ApplicationDetailsPage />} />
        <Route path={RoutePaths.customers.path} element={<CustomersPage />} />
        {hasAccountReadPermission && (
          <>
            <Route path={RoutePaths.customersTransactions.path} element={<TransactionsPage />} />
            <Route path={RoutePaths.customersAccountDetails.path} element={<AccountDetailsPage />} />
          </>
        )}
        {hasCustomerReadPermission && <Route path={RoutePaths.customersDetails.path} element={<CustomerDetailsPage />} />}
        <Route path={RoutePaths.manualApplications.path} element={<ManualApplicationsPage />} />
        <Route path={RoutePaths.manualApplicationsNew.path} element={<ManualApplicationDetailsPage />} />
        <Route path={RoutePaths.manualApplicationsDetails.path} element={<ManualApplicationDetailsPage />} />
        <Route path={RoutePaths.repository.path} element={<RepositoryPage />} />
        <Route path={RoutePaths.messages.path} element={<MessagesPage />} />
        <Route path={RoutePaths.messagesThread.path} element={<MessagesPage />} />
      </Route>
      <Route path='*' element={<Navigate to={RoutePaths.customers.onNavigate()} replace />} />
    </Routes>
  );
};
